import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LearningCenterService} from '../../../learning-center.service';
import {RecordsService} from '../../../records.service'
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'as-student-select',
  templateUrl: './student-select.component.html',
  styleUrls: ['./student-select.component.scss']
})
export class StudentSelectComponent implements OnInit {

  @ViewChild('customTables', {static: false}) customTables;
  @ViewChildren('checkedAllGroups') checkedAllGroups;
  @Output() emitSelectedStudents = new EventEmitter();
  @Output() emitSelectedGroups = new EventEmitter();
  @Output() studentgroups = new EventEmitter();

  @Input() currentData;
  @Input() studentId = null;
  @Input() updateBoradcast;

  studentList;
  defaultStudentList;
  originalList;
  groups = [];
  defaultGroups;
  prePaginationGroups = [];
  groupStudentList;
  selectedStudents = new Set();
  dataSubscriber = new EventEmitter();
  filterOnKeys = ["firstName", "lastName"];
  filterGroupKey = ["group_name"];
  preloader = true;
  expandGroupIndex: number;
  paginatedGroups = [];
  updatedStudentList = [];
  selectedList = new Set();
  selectedGroups = new Set();
  subscribers = [];
  // preFilteredGroups = [];

  tableHeaders = [
    {headerName: '', field: '', sortable: false, filter: false},
    {headerName: 'First Name', field: '', sortable: false, filter: true},
    {headerName: 'Last Name', field: '', sortable: false, filter: true},

  ];
  tableHeaders2 = [
    {headerName: 'First Name', field: '', sortable: false, filter: true},
    {headerName: 'Last Name', field: '', sortable: false, filter: true},

  ];

  constructor(private learningCenterService: LearningCenterService, private RecordsService: RecordsService, private http: HttpClient) {
  }

  ngOnInit() { 
    // this.subscribers.push(this.updateBoradcast.subscribe((students)=>{
    //   // this.clearSelected();
    
        
    //   //     this.currentData = students;
    //   //     this.selectedStudents = new Set(students);
    //   //     this.mapCurrentDataToSelected();
    //   //     console.log(students)
    
    // }));
    this.fetch();
  }

  fetch() {
   this.subscribers.push(this.learningCenterService.getUsersProfiles().subscribe((e) => {

      if (this.studentId) {
        this.learningCenterService.fetchUsersNames();
        setTimeout(() => {
          this.passSelectedItem({item: this.studentId, selected: true})
        }, 2000)
      }

      this.originalList = e; //does not get modified by filter
      this.defaultStudentList = e; //does not get modified by pagination
      this.dataSubscriber.emit(e); //lets pagination/table have the data

      //temporary...

      let url = '/networks/getUsersAndGroups.json'
      this.http.get(url).subscribe((c) => {
        for (let [key, value] of Object.entries(c)) {
          value["groupId"] = key;
          this.groups.push(value);
        }
        //assign student to group

        this.groups.forEach((g) => {
          g['students'] = [];
          g["selectedCount"] = 0;
          g.Users.map((s) => {
            let stu = e.find((st) => st.id == s);
            g['students'].push(stu);
          })
        })
        this.preloader = false;
        this.defaultGroups = this.groups;
        this.studentgroups.emit(this.defaultGroups);

        if (this.currentData && this.currentData.size > 0) {
          //we can pre-populate selected items from outside the component
          this.selectedStudents = this.currentData;

          this.mapCurrentDataToSelected();
        }
      })
    })
   )
  }

  passSelectedItem(event) {

    let student = this.originalList.find((e) => e.id == event.item);
    student["groupIds"] = [];

    this.groups.forEach((g) => {
      if (g.Users.includes(student.id)) {
        student["groupIds"].push(parseInt(g.groupId));
      }
    })

    if (!this.selectedStudents.has(student)) {
      this.selectedStudents.add(student)
    } else {
      this.selectedStudents.delete(student)
    }
    let st = this.originalList.indexOf(student);

    this.originalList[st]['selected'] = !(this.originalList[st]['selected'])

    this.updateGroupSelectedCount(this.groups, Array.from(this.selectedStudents));
    this.emitSelectedStudents.emit(this.selectedStudents);
  }

  handleAllSelected(e, subtable?: boolean) {
    //we're selecting all items, instead of just 1st page (default functionality)

    if (subtable) {
      this.originalList.forEach((f) => {
        f["groupIds"] = [];
        if (f.selected == true) {

          this.groups.forEach((g) => {
            if (g.Users.includes(f.id)) {
              f["groupIds"].push(parseInt(g.groupId));
            }
          })

          this.selectedStudents.add(f)
        }
        if (f.selected == false) {
          this.selectedStudents.delete(f)
        }
      })
    } else {

      this.selectedStudents.clear();
      this.defaultStudentList.map((d) => {
        d["selected"] = (e.length > 0);
        if (d["selected"]) {
          this.selectedStudents.add(d)
        }
      })
    }
    this.updateGroupSelectedCount(this.groups, Array.from(this.selectedStudents));
    this.emitSelectedStudents.emit(this.selectedStudents);
  }

  updateDataFromPagination(event) {
    this.studentList = event;
  }

  updateDataFromPaginationGroup(event, index) {
    // this.groups[index].students = event;
    setTimeout(() => {
      this.updatedStudentList[index] = event;
    })
  }

  filter(e) {
    this.defaultStudentList = e;
  }

  clearSelected() {

    this.selectedStudents.clear();
    this.selectedGroups.clear();
    this.originalList.map((e) => {
      e["selected"] = false;
    })

    this.groups.map((g) => {
      g.selectedCount = 0;
    });

    this.checkedAllGroups.forEach((c) => {
      c.model = false;
    })

    this.dataSubscriber.emit(this.originalList);
    this.emitSelectedStudents.emit(this.selectedStudents);
    this.emitSelectedGroups.emit([]);
  }

  updateData(event, clear?: boolean) {
    this.groups = event;
  }

  clearGroups(event) {
    this.groups = this.defaultGroups;
    this.updateGroupSelectedCount(this.groups, Array.from(this.selectedList));
    this.selectedGroups.clear();
    this.emitSelectedGroups.emit([]);
  }

  mapCurrentDataToSelected() {
    let d = Array.from(this.currentData);

    this.defaultStudentList.map((e) => {
      if (d.some((s) => s['id'] == e.id)) {
        e['selected'] = true;
      }
    });

    this.updateGroupSelectedCount(this.groups, Array.from(this.currentData));
  }

  expandGroup(index) {
    if (index == this.expandGroupIndex) {
      this.expandGroupIndex = undefined
    } else {
      this.expandGroupIndex = index;
    }

  }

  selectAllGroup(event: boolean, id: number) {

    let group = this.groups[this.groups.findIndex((g) => g.groupId == id)];

    group.students.map((s) => {

      s["selected"] = event;

      if (event) {
        this.selectedList.add(s);
      } else {
        this.selectedList.forEach((d) => {

          if (d["id"] == s.id) {
            this.selectedList.delete(d);
          }
        })
      }
    });


    // if (event){
    //   this.selectedGroups.add(group);
    //   this.selectedGroups.forEach((g)=>{
    //     if (g['selectedCount'] == g['students'].length){
    //       this.selectedGroups.add(g)
    //     }
    //   });
    // } else {
    //   this.selectedGroups.delete(group);
    //   this.selectedGroups.forEach((g)=>{
    //     if (g['selectedCount'] != g['students'].length){
    //       this.selectedGroups.delete(g)
    //     }
    //   });
    // }
 


this.selectedStudents = this.selectedList;
this.updateGroupSelectedCount(this.groups, Array.from(this.selectedList));
this.emitSelectedStudents.emit(this.selectedStudents);

this.groups.forEach(gr=>{

  if (gr.students.length != 0){
      if (gr.selectedCount == gr.students.length){
        this.selectedGroups.add(gr)
      } 
    }
      if (gr.selectedCount != gr.students.length){
        this.selectedGroups.delete(gr)
      }   
});

this.emitSelectedGroups.emit( this.selectedGroups);




      // this.selectedGroups.forEach((g)=>{
      //   if(g['selectedCount'] != g['students'].length){
      //     this.selectedGroups.delete(g);
      //   }
      //   if (g['selectedCount'] == g['students'].length){
      //     this.selectedGroups.add(g)
      //   }
      // })


  }

  updateGroupSelectedCount(group, selectedItems) {

    group.map((g, i) => {
      g.selectedCount = selectedItems.filter((s) => s.selected && g.Users.includes(s.id)).length;
    })
  }

  ngOnDestroy() {
    this.subscribers.forEach((s) => s.unsubscribe());
  }

}
